import { FeedbackType } from '@quadminds/client-apis/agents';
import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import useCreateGeneralFeedback from './useCreateGeneralFeedback';
import { useByPassContext } from '../providers/ByPass/ByPass.provider';

const useFeedbackDialog = () => {
    const queryClient = useQueryClient();
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [feedback, setFeedback] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const userInfo: IAuthMeV2OutputDto | undefined = queryClient.getQueryData(['userInfo']);
    const { isImpersonated } = useByPassContext();
    const { createFeedbackMutation } = useCreateGeneralFeedback({
        setOpen: setIsDialogOpen,
        setFeedback,
        setSubmitting: setIsSubmitting,
    });

    const handleSubmit = async (feedbackType: FeedbackType) => {
        if (feedback.trim().length === 0) return;

        setIsSubmitting(true);
        createFeedbackMutation.mutate({
            user_id: userInfo?.id || '',
            text: feedback.trim(),
            user_name: userInfo?.firstName + ' ' + userInfo?.lastName || '',
            type: feedbackType,
            is_impersonated: isImpersonated,
        });
    };

    const handleClose = () => {
        setIsDialogOpen(false);
        setFeedback('');
    };

    return {
        isDialogOpen,
        setIsDialogOpen,
        feedback,
        setFeedback,
        isSubmitting,
        handleSubmit,
        handleClose,
        userInfo,
        isImpersonated,
    };
};

export default useFeedbackDialog;
